






































import Vue from 'vue';
import { Button } from '@/components/ds';
import ProuniHeader from '@/components/prouni/ProuniHeader.vue';
import { getAssetPath } from '@/helpers/assets';
import prouniAuth from '@/helpers/prouniAuth';
import { PROUNI_VOUCHER_QUERY_PARAM } from '@/helpers/prouniVoucher';

/**
 * Tela da entrada da matrícula pelo link do ProUni (`/?cupom=...`). Dois modos:
 * `login` (pede a sessão Pocket) e `error` (a troca de token foi recusada).
 * O tom espelha o `ProuniNotEligible.vue`: explica o motivo e oferece trocar de
 * conta, em vez de jogar o aluno no processo seletivo.
 */
export default Vue.extend({
  name: 'ProuniEnrollmentLinkGate',
  components: { Button, ProuniHeader },
  props: {
    mode: {
      type: String,
      default: 'login',
      validator: (value: string) => ['login', 'error'].includes(value),
    },
    loggedEmail: {
      type: String,
      default: '',
    },
    voucher: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      heroImageSrc: getAssetPath('img/prouni/hero-not-eligible.svg'),
    };
  },
  computed: {
    isError(): boolean {
      return this.mode === 'error';
    },
  },
  methods: {
    switchAccount() {
      prouniAuth.logout();
      // Recarrega do zero (o estado do iframe/sessão do pocket é reconstruído)
      // mantendo o cupom na URL, para o link continuar valendo depois do login
      // com a conta certa.
      const query = this.voucher
        ? `?${PROUNI_VOUCHER_QUERY_PARAM}=${encodeURIComponent(this.voucher)}`
        : '';
      window.location.href = `/${query}`;
    },
  },
});
